/**
 * Create Context for our component library to pass on additional props
 */

import React from 'react';

const PolarisContext = React.createContext();
PolarisContext.displayName = 'Polaris';
export default PolarisContext;
